import React from 'react';
import { Radio } from 'antd';

export default class StatusRadioGroup extends React.Component {
	handleChange = (event) => this.props.onChange(event, this.props.statusType);
	render() {
		const value = (this.props.value)? this.props.value : 
					  (this.props.defaultValue)? this.props.defaultValue:
					  ''; 
		return (
			<Radio.Group onChange={this.handleChange} value={value}>
				<Radio.Button value="">Unreceived</Radio.Button>
				<Radio.Button value="I">Incomplete</Radio.Button>
				<Radio.Button value="R">Processing</Radio.Button>
				<Radio.Button value="A">Approved</Radio.Button>
				<Radio.Button value="W">Waived</Radio.Button>
			</Radio.Group>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/StatusRadioGroup/index.jsx